module.exports = {
  AurigaThree: "Auriga 3",
  AutoCabs: "AutoCabs",
  Demesix: "Demesix",
  Nortelia: "Nortelia",
  TaxitronicWhiskyTwo: "Taxitronic Whisky 2",
  Treelogic: "Treelogic",
  KBO: "KBO",
  Tagos: "Tagos",
};
